
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import BPSectionHeader from '../snippets/BPSectionHeader.vue'
import { AlButton } from '~/components/ui'
import ResponsiveImage from '~/components/ResponsiveImage/ResponsiveImage.vue'
import { getExternalCompareHomeHref, getExternalCompareMobileHref } from '~/utils/external-links.utils'
import IconArrow from '~/assets/images/icons/icon-arrow-right-clear.svg?inline'
import { NotifiesOfferType } from '~/services/notifier.service'

const onlyMobile = ['spusu', 'talktalk', 'mtel']

@Component({
  components: {
    AlButton,
    BPSectionHeader,
    ResponsiveImage,
    IconArrow,
  },
})
export default class BPPlans extends Vue {
  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: String, required: true })
  subTitle!: string

  @Prop({
    type: String,
  })
  readonly offerType?: NotifiesOfferType

  @Prop({
    type: String,
  })
  readonly providerSlug?: string

  get externalCompareMobileHref (): string {
    return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath, this.providerSlug)
  }

  get externalCompareHomeHref (): string {
    if (onlyMobile.includes(this.providerSlug ?? '')) {
      return getExternalCompareHomeHref(this.$config.BASE_URL, this.localePath)
    }
    return getExternalCompareHomeHref(this.$config.BASE_URL, this.localePath, this.providerSlug)
  }

  get isMobileOffer (): boolean {
    return this.offerType === NotifiesOfferType.MOBILE_OFFER || !this.offerType
  }

  get isHomeOffer (): boolean {
    return this.offerType === NotifiesOfferType.HOME_OFFER || !this.offerType
  }
}
